import { NgxPaginationModule } from 'ngx-pagination';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from 'src/app/components/components.module';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { AccountSummaryComponent } from './account-summary.component';
import { FormsModule } from '@angular/forms';
import { DateDefaultFormatPipe } from 'src/app/pipes/date-format.pipe';


@NgModule({
  declarations: [
    AccountSummaryComponent
  ],
  imports: [
    CommonModule,
    NgxPaginationModule,
    IonicModule,
    ComponentsModule,
    PipesModule,
    FormsModule,
    DateDefaultFormatPipe, 
  ]
})
export class AccountSummaryModule {}